var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  className: "close_svg__svg-safari-fix",
  viewBox: "0 0 24 24",
  "aria-hidden": props["aria-label"] || props["aria-labelledby"] ? undefined : true
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m3.688-13.71a1 1 0 0 1 .004 1.415l-2.277 2.29 2.29 2.278a1 1 0 0 1-1.41 1.418l-2.29-2.277-2.279 2.291a1 1 0 0 1-1.418-1.41l2.278-2.291-2.291-2.278a1 1 0 0 1 1.41-1.419l2.291 2.278 2.278-2.29a1 1 0 0 1 1.414-.004",
  clipRule: "evenodd"
})));
export default SvgClose;